import VueWaypoint from 'vue-waypoint'

const _get = (value, path, defaultValue) => {
  return String(path).split('.').reduce((acc, v) => {
    try {
      acc = acc[v]
    } catch (e) {
      return defaultValue
    }
    return acc
  }, value)
}

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Vue = require('vue');

Vue.component('action-icons', require('./components/common/ActionIcons.vue').default);
Vue.component('main-nav', require('./components/site/MainNav.vue').default);
Vue.component('main-nav-mobile-button', require('./components/site/MainNavMobileButton.vue').default);
Vue.component('home-slider', require('./components/site/HomeSlider.vue').default);
Vue.component('home-history', require('./components/site/HomeHistory.vue').default);
Vue.component('region-map', require('./components/site/RegionMap.vue').default);
Vue.component('up-counter', require('./components/site/UpCounter.vue').default);
Vue.component('relevant-facts', require('./components/site/RelevantFacts.vue').default);

Vue.component('about-us-history', require('./components/site/AboutUsHistory.vue').default);
Vue.component('about-us-certifications', require('./components/site/AboutUsCertifications.vue').default);
Vue.component('image-slider', require('./components/site/ImageSlider.vue').default);

Vue.component('business-lines', require('./components/site/BusinessLines.vue').default);

Vue.component('the-modal', require('./components/common/TheModal.vue').default);
Vue.component('popup-component', require('./components/site/PopupComponent.vue').default);

Vue.use(VueWaypoint)

Vue.prototype.trans = string => _get(window.i18n, string);

const app = new Vue({
  el: '#app',
});
